// @ts-nocheck

import { TUnknownParam } from '@utils/diff/helpers';
type TCallback = (...args: TUnknownParam[]) => void | Promise<void>;

export {};

const root: typeof globalThis =
  (typeof globalThis !== 'undefined' && globalThis) || (typeof self !== 'undefined' && self) || (typeof global !== 'undefined' && global);

function isConstructor(fn: TUnknownParam): boolean {
  try {
    new fn('');
  } catch (error) {
    return false;
  }
  return true;
}

if (typeof root.Event !== 'function' || !isConstructor(root.Event)) {
  root.Event = (function () {
    function Event(type: string, options: TUnknownParam): void {
      this.bubbles = !!options && !!options.bubbles;
      this.cancelable = !!options && !!options.cancelable;
      this.composed = !!options && !!options.composed;
      this.type = type;
    }

    return Event;
  })();
}

if (typeof root.EventTarget === 'undefined' || !isConstructor(root.EventTarget)) {
  root.EventTarget = (function () {
    function EventTarget(): void {
      this.__listeners = new Map();
    }

    EventTarget.prototype = Object.create(Object.prototype);

    EventTarget.prototype.addEventListener = function (type: string, listener: TCallback, options: TUnknownParam) {
      if (arguments.length < 2) {
        throw new TypeError(
          `TypeError: Failed to execute 'addEventListener' on 'EventTarget': 2 arguments required, but only ${arguments.length} present.`,
        );
      }
      const __listeners: Map<TCallback> = this.__listeners;
      const actualType: string = type.toString();
      if (!__listeners.has(actualType)) {
        __listeners.set(actualType, new Map());
      }
      const listenersForType: TCallback[] = __listeners.get(actualType);
      if (!listenersForType.has(listener)) {
        // Any given listener is only registered once
        listenersForType.set(listener, options);
      }
    };

    EventTarget.prototype.removeEventListener = function (type: string, listener: TCallback, _options: TUnknownParam) {
      if (arguments.length < 2) {
        throw new TypeError(
          `TypeError: Failed to execute 'addEventListener' on 'EventTarget': 2 arguments required, but only ${arguments.length} present.`,
        );
      }
      const __listeners: Map<TCallback> = this.__listeners;
      const actualType: string = type.toString();
      if (__listeners.has(actualType)) {
        const listenersForType: TCallback[] = __listeners.get(actualType);
        if (listenersForType.has(listener)) {
          listenersForType.delete(listener);
        }
      }
    };

    EventTarget.prototype.dispatchEvent = function (event: string) {
      if (!(event instanceof Event)) {
        throw new TypeError(`Failed to execute 'dispatchEvent' on 'EventTarget': parameter 1 is not of type 'Event'.`);
      }
      const type: string = event.type;
      const __listeners: Map<TCallback> = this.__listeners;
      const listenersForType: TCallback[] = __listeners.get(type);
      if (listenersForType) {
        for (const [listener, options] of listenersForType.entries()) {
          try {
            if (typeof listener === 'function') {
              listener.call(this, event);
            } else if (listener && typeof listener.handleEvent === 'function') {
              listener.handleEvent(event);
            }
          } catch (err) {
            setTimeout(() => {
              throw err;
            });
          }
          if (options && options.once) {
            // If this was registered with { once: true }, we need
            // to remove it now.
            listenersForType.delete(listener);
          }
        }
      }
      return true;
    };

    return EventTarget;
  })();
}
